<template>
	<v-form ref="formActual">
		<v-container grid-list-lg>
			<v-row>
				<v-col cols="4">
					¿Es factible la aplicación de Bioimpedancia Eléctrica?
				</v-col>
				<v-col cols="4">
					<v-radio-group
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						v-model="valor.Factible"
					>
						<v-radio label="Sí" :value="true"></v-radio>
						<v-radio label="No" :value="false"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Pliegue Cutáneo Tricipital
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[!!valor.PliegueCutaneo || 'Campo Obligatorio']"
						type="number"
						v-model="valor.PliegueCutaneo"
						suffix="cm"
						hide-details="auto"
						class="campo-formulario"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Circunferencia Media de Brazo
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!!valor.CircunferenciaBrazo || 'Campo Obligatorio'
						]"
						type="number"
						v-model="valor.CircunferenciaBrazo"
						suffix="cm"
						hide-details="auto"
						class="campo-formulario"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Área muscular de brazo corregida
				</v-col>
				<v-col cols="4">
					<v-text-field
						hide-details="auto"
						class="campo-formulario"
						:disabled="true"
						solo
						:value="valor.AreaBrazoCorregida"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Percentil AMBc
				</v-col>
				<v-col cols="4">
					<v-text-field
						hide-details="auto"
						class="campo-formulario"
						:disabled="true"
						solo
						:value="valor.PercentilAMBC"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación AMBc
				</v-col>
				<v-col cols="4">
					<v-text-field
						hide-details="auto"
						class="campo-formulario"
						:disabled="true"
						solo
						:value="valor.InterpretacionAMBC"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					% de grasa corporal
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.PorcentajeGrasaCorporal ||
								'Campo Obligatorio'
						]"
						type="number"
						v-model="valor.PorcentajeGrasaCorporal"
						suffix="%"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación
				</v-col>
				<v-col cols="4">
					<v-radio-group
						:rules="[
							!valor.Factible ||
								!!valor.InterpretacionGrasaMuscular ||
								'Campo Obligatorio'
						]"
						v-model="valor.InterpretacionGrasaMuscular"
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						:disabled="!valor.Factible"
					>
						<v-radio label="Bajo" value="bajo"></v-radio>
						<v-radio label="Adecuado" value="adecuado"></v-radio>
						<v-radio label="Alto" value="alto"></v-radio>
						<v-radio label="Muy alto" value="muy alto"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Masa magra
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.MasaMagra ||
								'Campo Obligatorio'
						]"
						v-model="valor.MasaMagra"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación
				</v-col>
				<v-col cols="4">
					<v-radio-group
						:rules="[
							!valor.Factible ||
								!!valor.InterpretacionMasaMagra ||
								'Campo Obligatorio'
						]"
						v-model="valor.InterpretacionMasaMagra"
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						:disabled="!valor.Factible"
					>
						<v-radio label="Bajo" value="bajo"></v-radio>
						<v-radio label="Adecuado" value="adecuado"></v-radio>
						<v-radio label="Alto" value="alto"></v-radio>
						<v-radio label="Muy alto" value="muy alto"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Masa de músculo-esquelético
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.MasaMusculoEsqueletico ||
								'Campo Obligatorio'
						]"
						v-model="valor.MasaMusculoEsqueletico"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación
				</v-col>
				<v-col cols="4">
					<v-radio-group
						:rules="[
							!valor.Factible ||
								!!valor.InterpretacionMasaMusculoEsqueletico ||
								'Campo Obligatorio'
						]"
						v-model="valor.InterpretacionMasaMusculoEsqueletico"
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						:disabled="!valor.Factible"
					>
						<v-radio label="Bajo" value="bajo"></v-radio>
						<v-radio label="Adecuado" value="adecuado"></v-radio>
						<v-radio label="Alto" value="alto"></v-radio>
						<v-radio label="Muy alto" value="muy alto"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Densidad ósea
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.DensidadOsea ||
								'Campo Obligatorio'
						]"
						v-model="valor.DensidadOsea"
						type="number"
						suffix="kg"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Agua Corporal Total
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.AguaCorporalTotal ||
								'Campo Obligatorio'
						]"
						v-model="valor.AguaCorporalTotal"
						type="number"
						suffix="litros"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación ACT
				</v-col>
				<v-col cols="4">
					<v-radio-group
						:rules="[
							!valor.Factible ||
								!!valor.InterpretacionACT ||
								'Campo Obligatorio'
						]"
						v-model="valor.InterpretacionACT"
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						:disabled="!valor.Factible"
					>
						<v-radio label="Bajo" value="bajo"></v-radio>
						<v-radio label="Normal" value="normal"></v-radio>
						<v-radio label="Alto" value="alto"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Agua Corporal Extracelular
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.AguaCorporalExtracelular ||
								'Campo Obligatorio'
						]"
						v-model="valor.AguaCorporalExtracelular"
						type="number"
						suffix="litros"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Interpretación ACE
				</v-col>
				<v-col cols="4">
					<v-radio-group
						:rules="[
							!valor.Factible ||
								!!valor.InterpretacionACE ||
								'Campo Obligatorio'
						]"
						v-model="valor.InterpretacionACE"
						hide-details="auto"
						class="campo-formulario"
						row
						mandatory
						:disabled="!valor.Factible"
					>
						<v-radio label="Bajo" value="bajo"></v-radio>
						<v-radio label="Normal" value="normal"></v-radio>
						<v-radio label="Alto" value="alto"></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Ángulo de fase
				</v-col>
				<v-col cols="4">
					<v-text-field
						:rules="[
							!valor.Factible ||
								!!valor.AnguloFase ||
								'Campo Obligatorio'
						]"
						v-model="valor.AnguloFase"
						type="number"
						suffix="°"
						hide-details="auto"
						class="campo-formulario"
						:disabled="!valor.Factible"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="4">
					Observaciones
				</v-col>
			</v-row>
			<v-row :justify="'center'">
				<v-col cols="9">
					<v-textarea
						outlined
						v-model="valor.Observaciones"
					></v-textarea>
				</v-col>
			</v-row>
			<v-layout row class="mt-3">
				<v-flex xs6>
					<v-btn color="primary" @click.prevent="anterior">
						<v-icon>arrow_back_ios</v-icon> ANTERIOR
					</v-btn>
				</v-flex>
				<v-flex xs6 class="text-right">
					<v-btn color="primary" @click.prevent="guardar">
						<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
					</v-btn>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
import ServicioHistorialClinico from "../../../services/historialClinico";
export default {
	props: ["datos", "esHombre", "edad"],
	name: "resultadosBioimp",
	data() {
		return {
			valor: {}
		};
	},
	computed: {
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	methods: {
		actualizarFormulas() {
			console.log("actualizando");
			this.valor.AreaBrazoCorregida = this.$root.formulas.areaMuscularBrazoCorregida(
				this.valor.CircunferenciaBrazo,
				this.valor.PliegueCutaneo
			);
			this.valor.PercentilAMBC = this.$root.formulas.percentilAMBC(
				this.edad,
				this.valor.AreaBrazoCorregida,
				this.esHombre
			);
			this.valor.InterpretacionAMBC = this.$root.formulas.interpretacionAMBC(
				this.valor.PercentilAMBC
			);
		},
		siguiente() {
			this.$emit("siguiente");
		},
		anterior() {
			this.$emit("anterior");
		},
		async guardar() {
			if (this.$refs.formActual.validate()) {
				const res = await ServicioHistorialClinico.guardarResultadosBioimpedancia(
					this.historiaCliniciaId,
					this.valor
				);
				if (res.data.result === 1) {
					this.siguiente();
				} else {
					this.$root.mensajeError = res.data.message;
				}
			} else {
				this.$root.mensajeError =
					"Por favor llene todos los campos requeridos";
			}
		}
	},
	mounted() {},
	watch: {
		valor: {
			deep: true,
			handler() {
				this.actualizarFormulas();
			}
		},
		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	}
};
</script>
<style>
.row {
	border-bottom: 1px solid #f3f3f3 !important;
}
</style>
